import React from 'react';
import useAppContext from '../../hooks/useAppContext';
import Loading from '../Loading';

export default function LoadingIndicator() {
  const { isLoading } = useAppContext();
  return (
    <Loading isLoading={isLoading} withBackDrop />
  );
}
